import script from "./BaseItemDialogPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseItemDialogPreview.vue?vue&type=script&setup=true&lang=ts"

import "./BaseItemDialogPreview.vue?vue&type=style&index=0&id=39c8f08d&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c8f08d"]])

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide,QSeparator,QBtn,QIcon});
